
















import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    label: String,
    name: String,
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
})
export default class RadioButton extends Vue {

}
